module.exports = __webpack_public_path__ + "static/media/belum-memiliki-rumah.dfa9a9fe.png";